<template>
  <PullRefresh v-model="pageLoading" @refresh="onRefresh">
    <div
      class="rank-history"
      :style="'min-height:' + winHeight + 'px'"
    >
      <div class="banner">
        <img src="../../assets/ranking/banner_rank_history.png" />
        <div class="view-rule" @click="viewRule">查看规则>></div>
      </div>
      <!-- 日期切换 -->
      <div class="switch-date-wrapper">
        <Row type="flex" align="center" class="switch-date">
          <Col :span="4" @click="handleLeft" v-if="this.range != 3">
            <img
              class="switch-date-icon"
              src="../../assets/ranking/left_icon.png"
            />
          </Col>
          <Col :span="this.range != 3 ? 16 : 24" class="switch-date-time">
            {{startDate + (endDate ? '-' + endDate : '')}}
          </Col>
          <Col :span="4" @click="handleRight" v-if="this.range != 3">
            <img
              class="switch-date-icon switch-date-icon__right"
              src="../../assets/ranking/right_icon.png"
              :style="(weekIndex == -1 && monthIndex == 0) ? 'opacity: 0.6;' : ''"
            />
          </Col>
        </Row>
      </div>
      <!-- 个人/队伍 | 周/月/总积分排行榜 -->
      <div class="rank-history-list">
        <Title :name="rankTitle"></Title>
        <Loading class="loading-wrapper" v-if="pageShowLoading" size='20px'>加载中...</Loading>
        <template v-else>
          <template v-if="historyData.length > 0">
            <RankItem
              v-for="(item, index) in historyData"
              type="integral"
              :key="index"
              :rank="index+1"
              :avatar="item.headimgUrl"
              :nickname="item.nickName || item.teamName"
              :intro="item.about || item.address"
              :dataNumber="item.count"
            />
          </template>
          <Empty v-else/>
        </template>
        <Loading class="loading-end" v-if="pageEndLoading" size='20px'>加载中...</Loading>
        <div v-else class="loading-finished">{{finished ? '没有更多了' : ''}}</div>
      </div>
    </div>
  </PullRefresh>
</template>

<script>
// 历史积分排行榜
import { Row, Col, PullRefresh, Loading } from 'vant'
import Title from './Title'
import Empty from './Empty'
import RankItem from './RankItem'
import {
  getPersonalWeekIntegral, getPersonalMonthIntegral, getPersonalAllIntegral,
  getTeamWeekIntegral, getTeamMonthIntegral, getTeamAllIntegral
} from '@/api/rank'
export default {
  name: 'RankHistory',
  components: { PullRefresh, Row, Col, Loading, Title, Empty, RankItem },
  props: {},
  created () {
    const { type, range } = this.$route.query
    this.type = type
    this.range = range
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.getWinHeight()
    this.initData()
    this.initDate()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data () {
    return {
      historyData: [], // 历史排行榜数据
      typeMap: ['', '个人', '车队'],
      rangeMap: ['', '周', '月', '总'],
      startDate: '',
      endDate: '',
      type: 0,
      range: 0,
      monthIndex: 0, // 月份(...，-1:上一月, 0:当前月, 1:下一月，...)
      weekIndex: -1, // 周(...，-1:前一周, 0:当前周, 1:下一周，...)
      winHeight: 0,
      pageLoading: false,
      pageShowLoading: false,
      historyPagination: {
        page: 1,
        size: 10,
        total: 0
      },
      finished: false,
      pageEndLoading: false
    }
  },
  methods: {
    handleLeft () {
      this.finished = false
      this.historyPagination.page = 1
      if (Number(this.range) === 1) { // 周榜
        this.weekIndex = this.weekIndex - 1
        this.$nextTick(() => {
          this.initDate(true)
        })
      }
      if (Number(this.range) === 2) { // 月榜
        this.monthIndex = this.monthIndex - 1
        this.$nextTick(() => {
          this.initDate(true)
        })
      }
    },
    handleRight () {
      this.finished = false
      this.historyPagination.page = 1
      // 当到了最后的榜单，无法再往后
      if (this.weekIndex === -1 && this.monthIndex === 0) return
      if (Number(this.range) === 1) { // 周榜
        this.weekIndex = this.weekIndex + 1
        this.$nextTick(() => {
          this.initDate(true)
        })
      }
      if (Number(this.range) === 2) { // 月榜
        this.monthIndex = this.monthIndex + 1
        this.$nextTick(() => {
          this.initDate(true)
        })
      }
    },
    // 初始化数据
    initData () {
      this.getData(true)
    },
    // 初始化日期显示
    initDate (reqData = false, showLoading = true, page = 1) {
      let index = 0
      let dateArr = []
      if (Number(this.range) === 1) { // 周
        index = this.weekIndex
        dateArr = this.getWeek(index)
        this.startDate = this.formatDate(dateArr[0], 'MM/dd')
        this.endDate = this.formatDate(dateArr[1], 'MM/dd')
        reqData && this.getData(showLoading, { date: this.formatDate(dateArr[0], 'yyyy-MM-dd') }, page)
      }
      if (Number(this.range) === 2) { // 月
        index = this.monthIndex
        dateArr = this.getMonth(index)
        this.startDate = '-'
        this.endDate = '-'
        reqData && this.getData(showLoading, { month: this.formatDate(dateArr[0], 'yyyy-MM') }, page)
      }
      if (Number(this.range) === 3) { // 总榜
        dateArr = this.getYear()
        this.startDate = dateArr[0]
        this.endDate = dateArr[1]
        reqData && this.getData(showLoading, {}, page)
      }
    },
    // 请求数据
    getData (showLoading = false, params = {}, page) {
      const reqFun = this.getReqFun()
      this.pageShowLoading = showLoading
      this.pageLoading = !showLoading
      page = page || this.historyPagination.page
      params = { page, size: this.historyPagination.size, ...params }
      reqFun(params).then(res => {
        if (res.data.code === 0) {
          this.historyData = page === 1 ? res.data.data.items : this.historyData.concat(res.data.data.items)
          this.historyPagination.total = res.data.data.total || 0
          // 后台返回存在开始时间和结束时间时才使用后台给的数据(只有历史月数据有开始和结束时间返回)
          if (res.data.data.startTime || res.data.data.endTime) {
            // 日期做一个格式化显示
            this.startDate = this.formatDate(new Date(res.data.data.startTime), 'MM/dd')
            this.endDate = this.formatDate(new Date(res.data.data.endTime), 'MM/dd')
          }
          this.pageLoading = false
          this.pageShowLoading = false
          this.pageEndLoading = false
        } else {
          throw new Error(res.data)
        }
      }).catch(() => {
        this.historyPagination.total = 0
        this.pageLoading = false
        this.pageShowLoading = false
        this.pageEndLoading = false
      })
    },
    getReqFun () {
      if (Number(this.type) === 1) {
        if (Number(this.range) === 1) { return getPersonalWeekIntegral }
        if (Number(this.range) === 2) { return getPersonalMonthIntegral }
        if (Number(this.range) === 3) { return getPersonalAllIntegral }
      }
      if (Number(this.type) === 2) {
        if (Number(this.range) === 1) { return getTeamWeekIntegral }
        if (Number(this.range) === 2) { return getTeamMonthIntegral }
        if (Number(this.range) === 3) { return getTeamAllIntegral }
      }
    },
    /**
     * 获取某一周的日期
     * @param {number} index 第几周(...，-1:前一周, 0:当前周, 1:下一周，...)
     * @return 以数组形式返回这一周的开始日期和结束日期
     */
    getWeek (index) {
      const startIndex = index + 6 * index
      const dateOfToday = Date.now()
      const dayOfToday = (new Date().getDay() + 7 - 1) % 7
      // 当前周开始时间
      const dateWeekStart = new Date(dateOfToday + (startIndex - dayOfToday) * 1000 * 60 * 60 * 24)
      // 当前周结束时间
      const dateWeekEnd = new Date(dateOfToday + (startIndex + 6 - dayOfToday) * 1000 * 60 * 60 * 24)
      return [dateWeekStart, dateWeekEnd]
    },
    /**
     * 获取某一月
     * @param {number} index 第几月(...，-1:上一月, 0:当前月, 1:下一月，...)
     * @return 以数组形式返回这一月的年月显示
     */
    getMonth (index) {
      index = index || 0
      const date = new Date()
      const currentMonth = date.getMonth() // 0 - 11
      let startMonth = date.getMonth() + index
      let startYear = date.getFullYear()
      // 向前推,上个月，上上个月...
      if (index < 0 && currentMonth <= Math.abs(index)) {
        startMonth = 12 - ((Math.abs(index) - (currentMonth + 1)) % 12) - 1
        startYear = startYear - Math.ceil((Math.abs(index) - currentMonth + 1) / 12)
      }
      // 向后推，下个月，下下个月...
      if (index > 0) {
        startMonth = ((index + currentMonth + 1) > 12) ? (((index + currentMonth + 1) % 12) - 1) : (index + currentMonth)
        if (index + currentMonth + 1 > 12) {
          startYear = startYear + Math.floor((index + currentMonth + 1) / 12)
        }
      }
      const firstDay = new Date(startYear, startMonth, 1)
      return [firstDay, '']
    },
    // 获取年份的显示
    getYear () {
      // 需求： 总榜在19年显示2019，超过19年显示2019 - N，如2019 - 2020
      const date = new Date()
      const currentYear = date.getFullYear()
      if (currentYear === 2019) {
        return [2019, '']
      } else {
        return [2019, currentYear]
      }
    },
    formatDate (date, formatStr) {
      let result = ''
      result = formatStr.replace('yyyy', date.getFullYear())
              .replace('MM', String(date.getMonth() + 1).padStart(2, '0'))
              .replace('dd', String(date.getDate()).padStart(2, '0'))
      return result
    },
    // 获取当前窗口的高度
    getWinHeight () {
      this.winHeight = document.documentElement.clientHeight
      return document.documentElement.clientHeight
    },
    // 页面滚动处理
    handleScroll (e) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动到底部
      if (windowHeight + scrollTop - scrollHeight === 0) {
        if (this.pageEndLoading) {
          return false
        } else {
          this.loadmore()
        }
      }
    },
    // 加载更多
    loadmore () {
      const { page, size, total } = this.historyPagination
      const maxPage = Math.ceil(total / size)
      // 未达到最大页数继续加载更多数据
      if (page + 1 <= maxPage) {
        this.historyPagination.page = page + 1
        this.$nextTick(() => {
          this.pageEndLoading = true
          this.initDate(true, false, this.historyPagination.page)
        })
      } else {
        // 数据加载完成
        this.pageEndLoading = false
        if (this.historyData.length > 10) {
          this.finished = true
        }
      }
    },
    // 查看规则页面
    viewRule () {
      this.$router.push('/rankingrule')
    },
    // 下拉刷新
    onRefresh () {
      setTimeout(() => {
        this.finished = false
        this.historyPagination.page = 1
        this.initDate(true, false)
      }, 200)
    }
  },
  computed: {
    rankTitle () {
      if (!this.type || !this.range) return ''
      return this.typeMap[this.type] + '积分' + this.rangeMap[this.range] + '榜'
    }
  }
}
</script>

<style lang="less" scoped>
.loading-wrapper {
  padding-top: 25px;
  text-align: center;
}
.loading-end{
  padding: 20px 0;
  text-align: center;
}
.loading-finished{
  width: 100%;
  text-align: center;
  font-size: 12px;
  padding: 20px 0;
}
.rank-history-list .rank-item-wrapper:nth-last-child(2){
      margin-bottom: 0;
    }
.rank-item-wrapper{
  padding: 0;
}

.rank-history{
  .banner{
    position: relative;
    .view-rule{
      padding: 10px 10px 10px 16px;
      background-color: transparent;
      position: absolute;
      bottom: 38.5px;
      z-index: 2;
      color: #fff;
      font-size: 13px;
    }
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  &-list{
    padding: 0 22.5px;
  }
}
.switch-date{
  margin: 0 auto;
  width: 163px;
  height: 50px;
  .van-col{
    padding: 15px 0;
  }
  &-wrapper{
    height: 50px;
    background-color: #3257FF;
  }
  &-icon{
    width: 19px;
    height: 19px;
    display: block;
    &__right{
      float: right;
    }
  }
  &-time{
    font-size: 15px;
    text-align: center;
    color: #fff;
  }
}
</style>
